import React, { useState } from "react";
import logo from "../../../assets/aigiologo.svg";

import "./header.css";
import { Link } from "react-router-dom";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        {/* Hamburger */}

        {/* Logo */}
        <div className="header-left">
          <a
            href="/"
            aria-label="Go to landing page"
            className="header-logo-link"
          >
            <img src={logo} alt="AIGIO" className="header-logo" />
          </a>
        </div>
        <button
          className="mobile-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="5" width="20" height="2" rx="1" fill="#ffffff"/>
  <rect x="9" y="11.6" width="14" height="2" rx="1" fill="#ffffff"/>
  <rect x="15" y="18.2" width="8" height="2" rx="1" fill="#ffffff"/>
</svg>


        </button>

        {/* Desktop nav */}
        <nav className="header-nav">
          <a className="nav-link" href="/#how-it-works">
            Workflow{" "}
          </a>
          <a className="nav-link" href="/#audit">
            AI audit
          </a>
          <a className="nav-link" href="/#pricing">
            Pricing
          </a>
        </nav>

        {/* CTA */}
        <div className="header-cta">
          <a className="header-cta-button" href="/#pricing">
            Join Waitlist
          </a>
        </div>
      </div>

      {/* Mobile sidebar */}
      <div
        className={`mobile-sidebar-overlay ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      <aside className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
        <button
          className="mobile-sidebar-close"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        >
          &times;
        </button>

        <Link
          className="mobile-nav-link"
          to="/#how-it-works"
          onClick={() => setMenuOpen(false)}
        >
          Workflow
        </Link>

        <Link
          className="mobile-nav-link"
          to="/#audit"
          onClick={() => setMenuOpen(false)}
        >
          AI Audit
        </Link>

        <Link
          className="mobile-nav-link"
          to="/#pricing"
          onClick={() => setMenuOpen(false)}
        >
          Pricing
        </Link>

        <Link
          className="header-cta-button mobile-sidebar-cta"
          to="/#pricing"
          onClick={() => setMenuOpen(false)}
        >
          Join Waitlist
        </Link>
      </aside>
    </header>
  );
};

export default Header;
